<cm-list-item [selected]="$selected() ?? false" [disabled]="$disabled() ?? false">
    <ng-container cm-pre-title><i class="{{ $getNodeIconClass()($nodeClass()) }}"></i></ng-container>
    <ng-container cm-title
        ><div class="cm-offset-icons" [class.cm-value-node]="$isNodeValue()">
            {{ $displayLabel() }}<i class="{{ $getNodeIconSecondaryClass()($nodeClass()) }}"></i>
        </div>
    </ng-container>
</cm-list-item>
